// @flow

import React, { type Element } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ButtonInput,
  SCIENCE_BLUE,
  injectSheet,
  type InjectSheetProvidedProps
} from '@catalytic/catalytic-ui';

export const Style = () => ({
  root: {
    width: '100%',
    height: '2.5rem'
  }
});

type Props = InjectSheetProvidedProps & {
  children: string | Element<typeof FormattedMessage>,
  disabled: boolean,
  type: 'submit',
  value: string
};

export const LoginButton = ({
  classes,
  type,
  value,
  children,
  disabled,
  ...props
}: Props) => {
  return (
    <ButtonInput
      className={classes.root}
      colorScheme={SCIENCE_BLUE}
      data-testid="loginButton"
      type={type}
      value={value}
      disabled={disabled}
      {...props}
    >
      {children}
    </ButtonInput>
  );
};

LoginButton.displayName = 'LoginButton';

export default injectSheet(Style)(LoginButton);
